<template>
  <OurCard class="dealership-application-log-card mb-4" border-radius="sm">
    <div class="log-card-wrapper">
      <OurTextField :label="$t('label.id')" :value="idDisplay" />
      <OurTextField :label="$t('label.eventTypeLabel')" :value="eventTypeLabel || '—'" />
      <OurTextField :label="$t('label.comment')">
        <span class="log-comment">{{ comment || "—" }}</span>
      </OurTextField>
      <OurTextField :label="$t('label.statusAtEvent')" :value="statusAtEvent || '—'" />
      <OurTextField :label="$t('label.userData')">
        <div class="user-data">
          <span>{{ userData.fullName || "—" }}</span>
          <span>{{ userData.email || "—" }}</span>
        </div>
      </OurTextField>
      <OurTextField :label="$t('label.createdAtWithTime')" :value="createdAt || '—'" />
    </div>
  </OurCard>
</template>

<script>
export default {
  name: "DealershipApplicationLogCard",

  props: {
    id: {
      type: [String, Number],
      default: "",
    },
    eventTypeLabel: {
      type: String,
      default: "",
    },
    comment: {
      type: String,
      default: "",
    },
    statusAtEvent: {
      type: String,
      default: "",
    },
    userData: {
      type: Object,
      default: () => ({
        fullName: "",
        email: "",
      }),
    },
    createdAt: {
      type: String,
      default: "",
    },
  },

  computed: {
    idDisplay() {
      return this.id !== undefined && this.id !== null && this.id !== "" ? String(this.id) : "—";
    },
  },
};
</script>

<style scoped lang="postcss">
.dealership-application-log-card {
  @apply w-full min-w-0 max-w-full;

  .log-card-wrapper:deep {
    @apply flex w-full min-w-0 flex-col space-y-4;

    .our-text-field {
      @apply w-full min-w-0 max-w-full;
    }

    .user-data {
      @apply flex w-full min-w-0 flex-col gap-1;

      span {
        @apply min-w-0;
        overflow-wrap: anywhere;
        word-break: break-word;
      }
    }

    .log-comment {
      @apply block w-full min-w-0 max-w-full whitespace-pre-wrap text-gray-800;
      overflow-wrap: anywhere;
      word-break: break-word;
    }
  }
}
</style>
